// стили
import "../scss/style.scss";

// layout
import "./layout";

// how-to
import "./how-to";

// sliderArticlers
import "./catalog";

// contactForm
import "./contact-form";

// GDZ page
import "./gdz-article";

// Fonts page
import "./custom-pages";

import "./downloads";
import "./events";

// слайдер РСЯ
import "./ads-rsy";
import "./ads-rsy/renderFormats";